import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
export var ALL_FILTERS_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "We6D4A",
        defaultMessage: [
            {
                type: 0,
                value: "All Filters"
            }
        ]
    });
};
export var MORE_FILTERS_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "hsB+tw",
        defaultMessage: [
            {
                type: 0,
                value: "More Filters"
            }
        ]
    });
};
export var SEE_MORE_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "b+AXL8",
        defaultMessage: [
            {
                type: 0,
                value: "See More"
            }
        ]
    });
};
export var SEE_LESS_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "1UjQUO",
        defaultMessage: [
            {
                type: 0,
                value: "See Less"
            }
        ]
    });
};
export var CLEAR_ALL_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "keOCn5",
        defaultMessage: [
            {
                type: 0,
                value: "Clear All"
            }
        ]
    });
};
export var APPLY_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "dPW8DG",
        defaultMessage: [
            {
                type: 0,
                value: "Apply"
            }
        ]
    });
};
export var APPLY_FILTERS_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "Cw1xbE",
        defaultMessage: [
            {
                type: 0,
                value: "Apply Filters"
            }
        ]
    });
};
export var SORT_BY_INTL_TEXT = function(strictLocalize) {
    return strictLocalize({
        id: "98a0b5",
        defaultMessage: [
            {
                type: 0,
                value: "Sort By"
            }
        ]
    });
};
export var getSearchInputPlaceholder = function(searchLabelText) {
    var filterSectionName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", strictLocalize = arguments.length > 2 ? arguments[2] : void 0;
    if (searchLabelText) {
        return searchLabelText;
    }
    return strictLocalize({
        id: "BckNTp",
        defaultMessage: [
            {
                type: 0,
                value: "Search for "
            },
            {
                type: 1,
                value: "filterSectionName"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        filterSectionName: filterSectionName
    }));
};
